// 物件削除
import BukkenRepository from '@/repositories/bukkenRepository'
export default {
  methods: {
    // 物件削除 確認
    deleteConfirm(id) {
      if (window.confirm('選択された物件の削除を行います。よろしいですか?')) {
        this._delete(id)
      }
    },
    // 物件削除 処理
    async _delete(id) {
      this.$store.dispatch('Loading/setLoading', true)
      await BukkenRepository.delete(id)
        .then(resp => {
          if (resp.result) {
            let property = this.$store.getters['Property/getProperty']
            let select = this.$store.getters['SelectProperty/getProperty']
            let status = this.$store.getters['SearchProperty/getStatus']
            let _property = _.reject(property, {
              id: id,
            })
            let _select = _.reject(select, {
              id: id,
            })
            status.total--
            status.to--
            if (status.to === 0) status.from--

            this.$store.commit('Property/setProperty', _property)
            this.$store.commit('SelectProperty/setProperty', _select)
            this.$store.commit('SearchProperty/setStatus', status)
            alert('物件データを削除しました。')
          } else {
            alert('物件データの削除に失敗しました。')
          }
        })
        .catch(e => {
          console.log(e)
          alert('物件データの削除に失敗しました。')
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
  },
}
